import {FC, useMemo, useState} from "react";
import {Flex, Input, Typography} from "antd";
import {EventsTable} from "../../components/EventsTable/EventsTable.tsx";
import {SearchOutlined} from "@ant-design/icons";
import {useEvents} from "../../queries/useEvents.ts";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";

export const CompletePage: FC = () => {
    const { data: events, isLoading, refetch } = useEvents('complete');

    const [filterString, setFilterString] = useState('');
    const filteredEvents = useMemo(() => events?.filter((event) =>
        event.name.includes(filterString) ||
        event.description?.includes(filterString)
    ), [events, filterString]);

    const { profile } = useOwnProfile();

    return (
        <Flex vertical gap={16} flex="1 0" style={{ width: '100%' }}>
            {profile?.role !== 'fir_reader' && (
                <Flex align="center" gap={16}>
                    <Input
                        size="large"
                        prefix={<SearchOutlined />}
                        placeholder="Поиск"
                        style={{ width: 'fit-content' }}
                        value={filterString}
                        onChange={({ target }) => setFilterString(target.value)}
                    />
                    <Typography.Text type="secondary">
                        Вы видите только те ивенты, в согласовании которых принимали участие
                    </Typography.Text>
                </Flex>
            )}
            <EventsTable
                events={filteredEvents}
                loading={isLoading}
                onUpdate={refetch}
            />
        </Flex>
    );
}